// Haptics: a light tap when a button, tab, switch or tick box is pressed, and a nudge for a danger button.
// web-haptics vibrates on Android and, on iOS Safari (no vibrate), clicks a hidden <input switch>.
import { WebHaptics } from 'web-haptics';

const haptics = new WebHaptics();
const tap = (input: Parameters<WebHaptics['trigger']>[0]) => { haptics.trigger(input).catch(() => { /* not allowed here */ }); };

document.addEventListener('click', e => {
  const el = (e.target as Element).closest?.('button, .btn, .tabs a, .pills a, .segmented a');
  if (!el || el.matches(':disabled, [aria-busy="true"]')) return;
  tap(el.matches('.danger') ? 'nudge' : 10);
});

// Ticks, radios and switches: a tap, plus a pop on ticks that replays on every change.
document.addEventListener('change', e => {
  const el = e.target;
  if (!(el instanceof HTMLInputElement) || (el.type !== 'checkbox' && el.type !== 'radio') || el.id.startsWith('web-haptics-')) return; // its own hidden switch
  const isSwitch = el.getAttribute('role') === 'switch';
  tap(isSwitch ? 15 : 8);
  if (isSwitch) return;
  el.classList.remove('pop');
  void el.offsetWidth; // restart the animation
  el.classList.add('pop');
});
